// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    isOpen: [], // for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    typoFontSize: config.typoFontSize,
    textfieldFontSize: config.textfieldFontSize,
    buttonFontSize: config.buttonFontSize,
    opened: true
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            id = action.id;
            return {
                ...state,
                isOpen: [id]
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.opened
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.fontFamily
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.borderRadius
            };
        case actionTypes.SET_TYPO_FONT_SIZE:
            return {
                ...state,
                typoFontSize: action.typoFontSize
            };
        case actionTypes.SET_TEXT_FIELD_FONT_SIZE:
            return {
                ...state,
                textfieldFontSize: action.textfieldFontSize
            };
        case actionTypes.SET_TEXT_BUTTON_FONT_SIZE:
            return {
                ...state,
                buttonFontSize: action.buttonFontSize
            };
        default:
            return state;
    }
};

export default customizationReducer;
